import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import TrackingAnalytic from 'app/models/tracking_analytic';

export default PageableBase.extend({
  model: TrackingAnalytic,
  key: 'processed_by_facilities',
  url: analyticsUrl('tracking/v2/facilities/processed'),
  pagingType: PAGING_TYPES.PER_PAGE,

  initialize(models, { dateRange, carrierSelection, facilityTypeSelection }) {
    this.dateRange = dateRange;
    this.carrierSelection = carrierSelection;
    this.facilityTypeSelection = facilityTypeSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.carrierSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.facilityTypeSelection, 'change', this.resetToFirstPage);
  },

  parseRecords(attrs) {
    const attributes = PageableBase.prototype.parseRecords.call(this, attrs);
    return attributes[0].countries[0].states.reduce((a, b) => a.concat(b.postal_codes), []);
  },

  paramsForFetch() {
    return {
      relative: true,
      country: 'US',
      start_date: this.dateRange.getStartDatetimeForParam().format('YYYY-MM-DD'),
      end_date: this.dateRange.getEndDatetimeForParam().format('YYYY-MM-DD'),
      ...this.carrierSelection.getParams(),
      ...this.facilityTypeSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/tracking_analytics.js